import { CustomizedConfirmDeleteModal, CustomizedRoundIcon } from 'components/common';
import Icon from 'components/common/Icons/icon';
import { useState } from 'react';
import { useProjectTreeStore } from 'store/projectContract.store';
import { useMutationDeleteStoredFilterBulkAssignToUser } from 'api/mutations/deleteStoredFilterBulkAssignToUser.mutation';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import { useQueryClient } from 'react-query';

export const DeleteBulkAssignToUserCell = ({ row }) => {
    const [show, setShow] = useState<boolean>(false);
    const { contract } = useProjectTreeStore();
    const { handleSnackBar } = useCustomSnackBar();
    const queryClient = useQueryClient();

    const { mutate } = useMutationDeleteStoredFilterBulkAssignToUser();

    const handleDelete = () => {
        if (!contract) return null;
        mutate(
            {
                contractId: contract.id,
                id: row.id,
            },
            {
                onSuccess: () => {
                    handleSnackBar('Successfully deleted!', 'success');
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => {
                    queryClient.invalidateQueries('getStoredFilterBulkAssignToUser');
                },
            },
        );
        setShow(false);
    };

    return (
        <div>
            <CustomizedRoundIcon onClick={() => setShow(true)}>
                <Icon name={'BIN'} />
            </CustomizedRoundIcon>
            <CustomizedConfirmDeleteModal
                isShowModal={show}
                hideModal={() => setShow(false)}
                text={`Are you sure you want to delete this rule?`}
                onConfirm={handleDelete}
            />
        </div>
    );
};
